import styled from 'styled-components';

import * as PageStylesConstants from 'components/modules/AutoruLayout/Page/Page.styles';
import * as PageContentStylesConstants from 'components/modules/AutoruLayout/PageContent/PageContent.styles';

import ErrorIconSrc from './error-icon.png';

const PAGE_CONTAINER_PADDING = [
  PageStylesConstants.PAGE_CONTAINER_PADDINGS.TOP,
  PageStylesConstants.PAGE_CONTAINER_PADDINGS.BOTTOM,
].map((position) => {
  return `var(${PageStylesConstants.PAGE_CONTAINER_PADDING_PREFIX_VAR}${position})`;
});
const PAGE_CONTENT_CONTAINER_PADDING = [
  PageContentStylesConstants.PAGE_CONTENT_CONTAINER_PADDINGS.TOP,
  PageContentStylesConstants.PAGE_CONTENT_CONTAINER_PADDINGS.BOTTOM,
].map((position) => {
  return `var(${PageContentStylesConstants.PAGE_CONTENT_CONTAINER_PADDING_PREFIX_VAR}${position})`;
});
const SUM_ALL_PADDINGS = `calc(${[
  ...PAGE_CONTAINER_PADDING,
  ...PAGE_CONTENT_CONTAINER_PADDING,
].join(' + ')})`;

export const VoidAside = styled.div``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  row-gap: 24px;

  min-height: calc(100dvh - ${SUM_ALL_PADDINGS});
`;

export const ErrorIcon = styled.img.attrs({ src: ErrorIconSrc })`
  width: 182px;
  height: 182px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  row-gap: 8px;
`;

const Text = styled.p`
  margin: 0;
`;

export const Title = styled(Text)`
  font: var(--font-heading-large-20_2);
  color: var(--color-black);
`;

export const Description = styled(Text)`
  font: var(--font-regular-15);
  color: var(--color-grey-11_60);
`;
